export const BUILD_CONFIG_HASH = '__CONFIG_HASH__';
export const RUNTIME_CONFIG_BASE_DIR = '/assets/config';
export const RUNTIME_CONFIG_FALLBACK_PATH = `${RUNTIME_CONFIG_BASE_DIR}/config.json`;

export function runtimeConfigUrl(configHash: string = BUILD_CONFIG_HASH): string {
    const safeHash = (configHash || '').trim();
    return `${RUNTIME_CONFIG_BASE_DIR}/config.${encodeURIComponent(safeHash)}.json`;
}
